<template>
  <TableList
    v-rect-loading="loading"
    class="notification-template-list"
    :listData="tableData"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    @create="addLayout"
  >
    <template #filter>
      <el-input
        v-model="searchTemplateName"
        clearable
        class="keywords-filter"
        :placeholder="$t(`${i18nPrefix}.label.layoutName`)"
        @input="handleKeywordsChange"
      ></el-input>
    </template>
    <template #page-bottom>
      <DialogWrapper
        :show.sync="deleteDialog.show"
        :loading="deleteDialog.loading"
        :title="deleteDialog.title"
        @save="handleDelete"
      ></DialogWrapper>
    </template>
  </TableList>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    TableList,
    DialogWrapper
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.notification',
      searchTemplateName: null,
      tableData: [],
      deleteDialog: {
        show: false,
        loading: false,
        id: null,
        title: null
      }
    }
  },
  computed: {
    deleteTip () {
      return this.$t(`${this.i18nPrefix}.message.deleteTip`)
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.layoutName`),
          dataKey: 'name'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: true,
          labelI18nKey: `${this.i18nPrefix}.label.edit`,
          onclick: this.handleEdit
        },
        delete: {
          show: true,
          labelI18nKey: `${this.i18nPrefix}.label.delete`,
          onclick: this.showDeleteDialog
        },
        view: {
          show: true,
          labelI18nKey: 'common.btn.view',
          onclick: this.handleView
        }
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('notificationTemplate', ['searchSystemLayoutTemplate', 'deleteSystemLayoutTemplate']),
    handleEdit (row) {
      this.$router.push({
        path: `/v-admin/system-notification-template-management/layout/edit/${row.id}`,
        query: this.$route.query
      })
    },
    handleView (row) {
      this.$router.push({
        path: `/v-admin/system-notification-template-management/layout/view/${row.id}`,
        query: this.$route.query
      })
    },
    async initData () {
      this.loading = true
      try {
        await this.searchTemplateList()
      } finally {
        this.loading = false
      }
    },
    async searchTemplateList () {
      this.parseQuery()
      const params = {
        search_template_name: this.searchTemplateName
      }
      if (!this.loading) {
        this.$eventBus.$emit('showLoading', true)
      }
      try {
        const resp = await this.searchSystemLayoutTemplate(params)
        if (resp) {
          this.tableData = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    addLayout () {
      this.$router.push('/v-admin/system-notification-template-management/layout/add')
    },
    async handleDelete () {
      this.deleteDialog.loading = true
      try {
        const resp = await this.deleteSystemLayoutTemplate(this.deleteDialog.id)
        if (resp) {
          this.deleteDialog.show = false
          this.searchTemplateList()
        }
      } finally {
        this.deleteDialog.loading = false
      }
    },
    showDeleteDialog (rowData) {
      this.deleteDialog.show = true
      this.deleteDialog.id = rowData.id
      this.deleteDialog.title = this.$t(`${this.i18nPrefix}.message.deleteLayout`, { name: rowData.name, company: rowData.companyI18nName })
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.formatSearchData, 1000)
      }
      this.keywordsSearchDebounce()
    },
    formatSearchData () {
      this.$router.push({
        query: {
          ...this.$route.query,
          name: this.searchTemplateName
        }
      })
    },
    parseQuery () {
      this.searchTemplateName = this.$route.query.name
    }
  },
  watch: {
    $route: {
      handler () {
        this.searchTemplateList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-template-list {
  .title {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .keywords-filter {
    width: 190px;
  }

  .header-btn {
    padding: 9px 20px;
    margin-left: 10px;
  }

  .el-button {
    border: 0;
  }

  .operate-btn {
    padding: 0;
  }
}
</style>
